<template>
  <div>
    <!-- //start-mid-section  -->
    <div class="bg-white pb-10 rounded-lg">
      <h1 class="main-text">Get a Quote</h1>
      <p class="text-center py-3">
        Enter your details below to get a quick shipment quote
      </p>

      <div class="shadow-md py-3 m-3 rounded-md">
        <!-- start shadow section -->
        <div
          class="p-3 flex justify-between flex-wrap rounded-lg bx-box"
          v-for="(item, index) in createdShipment"
          :key="index"
        >
          <div class="w-full">
            <h5 class="w-full text-lg flex items-center">
              <span class="block w-full">Shipment Type</span>
              <img
                class="cursor-pointer mx-2 width duration-300"
                :class="[
                  createdShipment.length > 1 ? 'opacity-100' : 'opacity-0',
                ]"
                @click="
                  createdShipment.length > 1 ? removeShipment(index) : null
                "
                src="@/assets/images/icons/delete-icon.svg"
                alt=""
              />
            </h5>
            <div
              class="w-full flex mt-1 gap-4 pt-3 pb-2 border-b-2 border-gray-400 mb-4"
            >
              <div>
                <label :for="'noEnd' + index" class="radio-label">
                  <input
                    class="bg-primary-yellow text-secondary-yellow"
                    :name="'routeEnd' + index"
                    type="radio"
                    :id="'noEnd' + index"
                    value="light"
                    v-model="item.shipmentType"
                  />
                  <i class="mx-2">
                    <svg
                      width="21"
                      height="15"
                      viewBox="0 0 21 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.0487 7.90006C13.5271 7.90006 13.0365 7.62233 12.7711 7.17795L10.7868 3.88834L8.80566 7.17795C8.53718 7.62541 8.04652 7.90315 7.52499 7.90315C7.38613 7.90315 7.24726 7.88463 7.11456 7.84451L2.88683 6.63483V12.1278C2.88683 12.5814 3.19542 12.9764 3.63363 13.0844L10.3054 14.7539C10.6202 14.8311 10.9504 14.8311 11.2621 14.7539L17.94 13.0844C18.3782 12.9733 18.6868 12.5783 18.6868 12.1278V6.63483L14.4591 7.84143C14.3264 7.88155 14.1875 7.90006 14.0487 7.90006ZM20.6094 4.43764L19.0201 1.26529C18.9244 1.07397 18.7177 0.962873 18.5048 0.990646L10.7868 1.97506L13.6166 6.66877C13.7339 6.86319 13.9684 6.95576 14.1875 6.89405L20.2946 5.15049C20.6001 5.061 20.7482 4.72155 20.6094 4.43764ZM2.55355 1.26529L0.96429 4.43764C0.822336 4.72155 0.973547 5.061 1.27597 5.1474L7.38304 6.89096C7.60214 6.95268 7.83667 6.8601 7.95394 6.66569L10.7868 1.97506L3.06581 0.990646C2.85288 0.965959 2.64921 1.07397 2.55355 1.26529Z"
                        fill="#383F51"
                      />
                    </svg>
                  </i>
                  Light Package
                  <span></span>
                </label>
              </div>

              <div >
                <label :for="'yesEnd' + index" class="radio-label">
                  <input
                    type="radio"
                    v-model="item.shipmentType"
                    value="heavy"
                    :id="'yesEnd' + index"
                    :name="'routeEnd' + index"
                  />

                  <i class="mx-2">
                    <svg
                      width="26"
                      height="20"
                      viewBox="0 0 26 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.3798 11.25H20.9076V15L19.5187 14.168L18.1298 15V11.25H14.6576C14.2756 11.25 13.9631 11.5312 13.9631 11.875V19.375C13.9631 19.7188 14.2756 20 14.6576 20H24.3798C24.7617 20 25.0742 19.7188 25.0742 19.375V11.875C25.0742 11.5312 24.7617 11.25 24.3798 11.25ZM7.71311 8.75H17.4353C17.8173 8.75 18.1298 8.46875 18.1298 8.125V0.625C18.1298 0.28125 17.8173 0 17.4353 0H13.9631V3.75L12.5742 2.91797L11.1853 3.75V0H7.71311C7.33116 0 7.01866 0.28125 7.01866 0.625V8.125C7.01866 8.46875 7.33116 8.75 7.71311 8.75ZM10.4909 11.25H7.01866V15L5.62977 14.168L4.24089 15V11.25H0.768663C0.386719 11.25 0.0742188 11.5312 0.0742188 11.875V19.375C0.0742188 19.7188 0.386719 20 0.768663 20H10.4909C10.8728 20 11.1853 19.7188 11.1853 19.375V11.875C11.1853 11.5312 10.8728 11.25 10.4909 11.25Z"
                        fill="black"
                      />
                    </svg>
                  </i>
                  Cargo/Heavy Package
                  <span></span>
                </label>
              </div>

              <div>
                <label :for="'yesFinish' + index" class="radio-label">
                  <input
                    type="radio"
                    v-model="item.shipmentType"
                    value="truck"
                    :id="'yesFinish' + index"
                    :name="'routeEnd' + index"
                  />

                  <i class="mx-2">
                    <svg
                      width="19"
                      height="14"
                      viewBox="0 0 19 14"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M14.3272 12.4167C13.9957 12.4167 13.6777 12.285 13.4433 12.0505C13.2089 11.8161 13.0772 11.4982 13.0772 11.1667C13.0772 10.8351 13.2089 10.5172 13.4433 10.2828C13.6777 10.0484 13.9957 9.91666 14.3272 9.91666C14.6587 9.91666 14.9766 10.0484 15.2111 10.2828C15.4455 10.5172 15.5772 10.8351 15.5772 11.1667C15.5772 11.4982 15.4455 11.8161 15.2111 12.0505C14.9766 12.285 14.6587 12.4167 14.3272 12.4167ZM15.5772 4.91666L17.2105 6.99999H13.4939V4.91666H15.5772ZM4.32719 12.4167C3.99567 12.4167 3.67773 12.285 3.44331 12.0505C3.20888 11.8161 3.07719 11.4982 3.07719 11.1667C3.07719 10.8351 3.20888 10.5172 3.44331 10.2828C3.67773 10.0484 3.99567 9.91666 4.32719 9.91666C4.65871 9.91666 4.97665 10.0484 5.21107 10.2828C5.44549 10.5172 5.57719 10.8351 5.57719 11.1667C5.57719 11.4982 5.44549 11.8161 5.21107 12.0505C4.97665 12.285 4.65871 12.4167 4.32719 12.4167ZM15.9939 3.66666H13.4939V0.333328H1.82719C0.902189 0.333328 0.160522 1.07499 0.160522 1.99999V11.1667H1.82719C1.82719 11.8297 2.09058 12.4656 2.55942 12.9344C3.02826 13.4033 3.66415 13.6667 4.32719 13.6667C4.99023 13.6667 5.62611 13.4033 6.09496 12.9344C6.5638 12.4656 6.82719 11.8297 6.82719 11.1667H11.8272C11.8272 11.8297 12.0906 12.4656 12.5594 12.9344C13.0283 13.4033 13.6641 13.6667 14.3272 13.6667C14.9902 13.6667 15.6261 13.4033 16.095 12.9344C16.5638 12.4656 16.8272 11.8297 16.8272 11.1667H18.4939V6.99999L15.9939 3.66666Z"
                        fill="#383F51"
                      />
                    </svg>
                  </i>
                  Haulage
                  <span></span>
                </label>
              </div>
            </div>

            <h5 class="w-full text-lg my-3">Details</h5>
            <div class="flex flex-wrap justify-between">
              <div class="flex justify-between flex-wrap w-5/12">
                <label class="w-full">Dimension (Cm)</label>
                <input
                  min="0"
                  @input="item.dimensionLength = Math.abs(item.dimensionLength)"
                  class="dim"
                  v-model="item.length"
                  placeholder="Length (cm)"
                  type="number"
                />
                <input
                  min="0"
                  @input="item.dimensionWidth = Math.abs(item.dimensionWidth)"
                  class="dim"
                  v-model="item.width"
                  placeholder="Width (cm)"
                  type="number"
                />
                <input
                  min="0"
                  @input="item.dimensionHeight = Math.abs(item.dimensionHeight)"
                  class="dim"
                  v-model="item.height"
                  placeholder="Height (cm)"
                  type="number"
                />
              </div>
              <div class="w-3/12">
                <label class="w-full"> Weight (Kg)</label>
                <input
                  @input="item.width = Math.abs(item.width)"
                  min="0"
                  class="property"
                  v-model="item.estimatedWeight"
                  placeholder="--Enter Weight--"
                  type="number"
                />
              </div>
              <div class="w-3/12">
                <label class="w-full"> Quantity</label>
                <input
                  class="property"
                  @input="item.quantity = Math.abs(item.quantity)"
                  v-model="item.quantity"
                  placeholder="--Enter Quantity--"
                  type="number"
                />
              </div>
            </div>

            <h5 class="w-full text-lg mb-4 mt-20">
              Not sure about the dimension? Select one that closely matches your
              shipment
            </h5>
            <div class="flex flex-wrap justify-between">
              <div
                class="select-box"
                v-for="(dim, i) in defaultDimension"
                :key="i"
                :class="[
                  item.initialDimIndex == i ? 'select-box-active' : null,
                ]"
                @click="setDefaultDimension(index, i)"
              >
                <span class="w-6/12">{{ dim.name }}</span>
                <span class="w-5/12">{{ dim.dim }}</span>
              </div>
            </div>

            <div class="w-full mt-20">
              <h5 class="w-full text-lg">Shipment Category</h5>
              <div class="w-full flex mt-1 gap-4 pt-3 pb-2 mb-4">
                <div >
                  <label :for="'Palletized' + index" class="radio-label">
                    <input
                      class="bg-primary-yellow text-secondary-yellow"
                      :name="'category' + index"
                      type="radio"
                      :id="'Palletized' + index"
                      value="palletized"
                      v-model="item.shipmentCategory"
                    />
                    Palletized
                    <span></span>
                  </label>
                </div>

                <div>
                  <label :for="'Non_tackable' + index" class="radio-label">
                    <input
                      type="radio"
                      v-model="item.shipmentCategory"
                      value="non-stackable"
                      :id="'Non_tackable' + index"
                      :name="'category' + index"
                    />
                    Non-stackable
                    <span></span>
                  </label>
                </div>

                <div>
                  <label :for="'fragile_items' + index" class="radio-label">
                    <input
                      type="radio"
                      v-model="item.shipmentCategory"
                      value="contains dangerous or fragile items"
                      :id="'fragile_items' + index"
                      :name="'category' + index"
                    />
                    Contains dangerous or fragile items
                    <span></span>
                  </label>
                </div>

                <div>
                  <label
                    :for="'Exclusively_documents' + index"
                    class="radio-label"
                  >
                    <input
                      type="radio"
                      v-model="item.shipmentCategory"
                      value="exclusively documents"
                      :id="'Exclusively_documents' + index"
                      :name="'category' + index"
                    />
                    Exclusively documents
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- end shadow section -->

        <div class="w-full px-4">
          <button
            @click="addShippment"
            class="flex items-center ml-4 mt-5 pb-4"
          >
            <img
              src="@/assets/images/icons/add.svg"
              alt="add icon"
              class="mr-2"
            />
            Add Another Shipment
          </button>
          <hr class="border-b-2 w-full border-gray-400" />
        </div>

        <div class="w-full flex mt-1 gap-4 pt-3 pb-2 mb-4 flex-wrap p-4">
          <h5 class="w-full text-lg my-3">Preferred Shipping Option</h5>
          <div >
            <label for="Door_to_Door" class="radio-label">
              <input
                class="bg-primary-yellow text-secondary-yellow"
                name="Shipping"
                type="radio"
                id="Door_to_Door"
                value="door-to-door"
                v-model="shippingMethod"
              />
              Door-to-Door
              <span></span>
            </label>
          </div>

          <div>
            <label for="Drop_off" class="radio-label">
              <input
                type="radio"
                v-model="shippingMethod"
                value="terminal-to-terminal"
                id="Drop_off"
                name="Shipping"
              />
              terminal-to-terminal
              <span></span>
            </label>
          </div>
          <hr class="border-b-2 w-full border-gray-400" />
        </div>

        <div class="w-full flex mt-1 gap-4 pt-3 pb-2 flex-wrap p-4">
          <h5 class="w-full text-lg my-3">Other Information</h5>

          <label class="w-full m-0 p-0">Declared Value (NGN)</label>
          <input
            @input="declaredValue = Math.abs(declaredValue)"
            v-model="declaredValue"
            class="w-4/12 bg-gray-200 p-2"
            placeholder="--Enter item value--"
            type="number"
          />

          <hr class="border-b-2 w-full border-gray-400" />
        </div>

        <div class="flex items-center w-full pt-12 px-4">
          <div class="w-6/12">
            <button @click="$emit('changeTabs', 'new-quote')">Cancel</button>
          </div>
          <div class="w-6/12 flex justify-end">
            <button class="primary-button" @click="submit">
              Get Your Quote
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- //end mid section -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      quote: {
        locationFrom: "",
        locationTo: "",
      },
      countries: ["Nigeria"],
      declaredValue: "",
      shippingMethod: "terminal-to-terminal",
      createdShipment: [
        {
          shipmentType: "light",
          length: null,
          width: null,
          height: null,
          shipmentCategory: "",
          description: "",
          quantity: null,
          itemValue: 0,
          initialDimIndex: -1,
          estimatedWeight: null,
          specialHandling: [],
        },
      ],
      defaultDimension: [
        {
          name: "A4 Envelope",
          dim: "32x24x1 cm",
          length: 32,
          width: 24,
          height: 1,
        },
        {
          name: "One or two books",
          dim: "23x14x4 cm",
          length: 23,
          width: 14,
          height: 4,
        },
        {
          name: "Shoe box",
          dim: "25x30x15 cm",
          length: 25,
          width: 30,
          height: 15,
        },
        {
          name: "Moving box",
          dim: "75x35x35 cm",
          length: 75,
          width: 35,
          height: 35,
        },
      ],
      initialDimIndex: -1,
    };
  },

  computed: {
    QuoteShippingId() {
      return this.$store.getters.quoteResponse?.shipping?.id;
    },
  },

  methods: {
    async submit() {

      // eslint-disable-next-line no-unused-vars
      const { userId, ...rest } = JSON.parse(localStorage.getItem("quote-darft-flow") || "{}");

      let payload = {
          ...rest,
          currentStep: 4,
          paymentStatus: "not paid",
          deliveryStatus: "Estimate",
          shippingMethod: this.shippingMethod,

          // id: this.QuoteShippingId,

          packages: [...this.createdShipment],
      };
      try {
        const response = await this.$_createQuote(payload);

        let splitPayload = payload;
        this.$store.dispatch("saveQuoteStore", splitPayload);
        // localStorage.removeItem('quote-darft-flow')
        this.$store.dispatch("saveQuoteResponse", response.data.data);
        this.$emit("changeTabs", "summary");
      } catch (error) {
        this.handleError(error);
      }
    },
    addShippment() {
      this.createdShipment.push({
        shipmentType: "",
        length: null,
        width: null,
        height: null,
        shipmentCategory: "",
        description: "",
        quantity: null,
        itemValue: null,
        estimatedWeight: null,
        specialHandling: [],
      });
    },
    setDefaultDimension(index, i) {
      this.createdShipment[index].initialDimIndex = i;
      this.createdShipment[index].height = this.defaultDimension[i]?.height;
      this.createdShipment[index].width = this.defaultDimension[i]?.width;
      this.createdShipment[index].length = this.defaultDimension[i]?.length;
    },
    removeShipment(i) {
      this.createdShipment = this.createdShipment.filter(
        (item, index) => index != i
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.main-text {
  font-size: 27px;
  @apply py-4 text-center pt-12;
}
.primary-button {
  @apply px-5 bg-primary-yellow py-3 rounded-md;
}
.single-option {
  @apply mx-2;
}
.dim {
  @apply px-2 py-2 border-2 border-gray-400 bg-gray-100;
  width: 32%;
}
.property {
  @apply px-2 py-2 border-2 border-gray-400 bg-gray-100 w-full;
}
.select-box {
  @apply flex items-center justify-between bg-gray-200 py-4 px-2 duration-300 cursor-pointer;
  width: 24%;
}
.select-box-active {
  @apply bg-primary-navy text-white;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  display: none;
}
.width {
  width: 25px;
}
.bx-box {
  @apply border-t-2 border-gray-200;
  margin: 6px;
  margin-top: 40px;
}
.bx-box:nth-of-type(1) {
  @apply border-t-2 border-transparent;
  margin: 6px;
  margin-top: 6px;
}
.radio-label {
  @apply flex items-center;
}
</style>
